// src/api/api.js
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_PATH || 'https://localhost:5001';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const walletApi = {
  getWallet: (userId) => api.get(`wallet/${userId}`),
  createOrder: (data) => api.post('wallet/create-order', data),
  verifyPayment: (data) => api.post('wallet/verify-payment', data),
  getTransactions: (userId, page = 1, pageSize = 10) => 
    api.get(`/api/wallet/${userId}/transactions?page=${page}&pageSize=${pageSize}`),
};

export default api;
